import Typography from "@/components/shared/Typography"
import { ReactNode, useState } from "react"

interface Props {
  question: ReactNode
  answer: ReactNode
}

const FAQItem = ({ question, answer }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="rounded bg-primary-500 p-6">
      <div className="flex cursor-pointer items-center justify-between" onClick={() => setIsOpen((prev) => !prev)}>
        <Typography type="h4">{question}</Typography>
        <span className="text-4xl leading-3 text-secondary-300">{isOpen ? "−" : "+"}</span>
      </div>

      {isOpen && (
        <Typography type="l" className="mt-2 text-primary-200">
          {answer}
        </Typography>
      )}
    </div>
  )
}

export default FAQItem
